const state = {
  whitelistedPostMessage: null,
}

const mutations = {
  SET_WHITELISTED_POST_MESSAGE(moduleState, payload) {
    Object.assign(moduleState, { whitelistedPostMessage: payload })
  },
  CLEAR_WHITELISTED_POST_MESSAGE(moduleState) {
    Object.assign(moduleState, { whitelistedPostMessage: null })
  },
}

const actions = {
  setWhitelistedPostMessage({ commit }, payload) {
    commit('SET_WHITELISTED_POST_MESSAGE', payload)
  },
  clearWhitelistedPostMessage({ commit }) {
    commit('CLEAR_WHITELISTED_POST_MESSAGE')
  },
}

const getters = {
  whitelistedPostMessage: moduleState => moduleState.whitelistedPostMessage,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
